export const SITE_BETA_DISCLAIMER =
  "shops.mt is in early beta. Prices and product information may be inaccurate or out of date — always verify on the retailer's website before purchasing.";

export const SITE_BETA_DISCLAIMER_DISMISSED_KEY =
  'shopsmt-beta-disclaimer-dismissed';
